<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} {{ $t('student.title') }} </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
            <!-- Product Image -->
        <template >
           <!-- <vs-button @click="openLoadingInDiv" >Div with Loading</vs-button> -->

            <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">
            <img v-if="checkImg" :src="dataImg" class="responsive">
            <!-- <img v-if="ImgName"  :src="img_cdn+ImgName" class="responsive"> -->
          </div>
          </div>
            </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} {{$t('student.add.image')}}</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click="ImgName = null , dataImg = null">{{$t('student.add.btn_remove_image')}}</vs-button>
          </div>
        </template>
        <!-- NAME -->
        <vs-input v-if="lng!='dogs'" label="First Name *" v-model="dataFirstName" class="mt-5 w-full" :name="$t('student.add.first_name')" v-validate="'required'" />
        <vs-input v-else :label="$t('student.add.first_name')" v-model="dataFirstName" class="mt-5 w-full" :name="$t('student.add.first_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('student.add.first_name'))">{{ errors.first($t('student.add.first_name')) }}</span>

        <vs-input v-if="lng!='dogs'" :label="$t('student.add.middle_name')"  v-model="dataMiddleName" class="mt-5 w-full" :name="$t('student.add.middle_name')"  />

        <vs-input v-if="lng!='dogs'" :label="$t('student.add.last_name')" v-model="dataLastName" class="mt-5 w-full" :name="$t('student.add.last_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('student.add.last_name'))">{{ errors.first($t('student.add.last_name')) }}</span>
         <!-- NICk Name -->
        <vs-input v-if="lng!='dogs'" :label="$t('student.add.nick_name')"  v-model="dataNick" class="mt-5 w-full" :name="$t('student.add.nick_name')"  /><br>
        <!-- <span class="text-danger text-sm" v-show="errors.has('Nick Name')">{{ errors.first('Nick Name') }}</span><br> -->
        <!-- CATEGORY -->
        <label class="vs-select--label w-full">{{$t('student.add.dob')}}</label>
      <vs-row>
  <vs-col  vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
    <datepicker class="w-full"  v-model="dataBirthday" format="MM/dd/yyyy"  :minimumView="'day'" :maximumView="'year'" :initialView="'month'"></datepicker><span v-if="dataBirthday" class="mb-8 ml-1"  @click="dataBirthday = null">x</span>

  </vs-col>
  <!-- <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
   </vs-col> -->
</vs-row><br>
        <label class="vs-select--label w-full">{{$t('student.add.location')}}</label>
        <ul class="centerx mt-2  flex flex-wrap">
         <li class="ml-1" v-for="location in locations" :key="location.id">
         <vs-radio v-model="dataLocation" @change="getLocation(location.id,'new')" :vs-value="location.id">{{location.name}}</vs-radio>
        </li>
        </ul><br>
        <label class="vs-select--label w-full">{{$t('student.add.program')}}</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataProgram"  :options="programs"  /><br>

        <!-- ORDER STATUS -->
        <label class="vs-select--label w-full">{{$t('student.add.users')}}</label>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataCamUser"  :options="camusers"   /><br>

        <label class="vs-select--label w-full">{{$t('student.add.cameras')}}</label>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataCamera"  :options="cameras"/><br>

        <!-- STATUS -->
        <vs-row vs-w="12" class="ml-6">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="2" vs-xs="1">
            <label>Status</label>
          </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="9">
        </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">
          <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row>


      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{$t('student.add.btn_submit')}}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('student.add.btn_cancel')}}</vs-button>
    </div>
  </vs-sidebar>
</template>




<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import {ALL_MANGER_LOCATIONS, CREATE_USER_ACTIVITY, UPDATE_USER_ACTIVITY} from '@/graphql'
import {ALL_CAMERAS} from '@/graphql'
import {ALL_USERS} from '@/graphql'
import {ALL_PROGRAMS_QUERY} from '@/graphql'
import {CREATE_STUDENT,UPDATE_STUDENT,STUDENTS_BY_MANAGER_LOCATION,ME_DATA,UPLOAD_IMAGE,UPDATE_USER_TO_SIBLING,GET_CAMERA_BY_LOCATION,GET_PROGRAM_BY_LOCATION} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    moment,
  },
  data () {
    return {
      checkImg:'',
      oldimage:'',
      ImgName:'',
      locations:[],
      camusers:[],
      cameras:[],
      programs:[],
      dataId: null,
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataProgram: [],
      dataCamUser: [],
      dataCamera:[],
      dataLocation:'',
      dataImg: null,
      dataNick:'',
      dataStatus:false,
      dataBirthday:'',
      settings: { // perfectscrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: .60,
      file:'',
      meID:'',
      meRole:'',
      img_cdn:'',
      lng:'',
      CamUser:[],
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id,fname,lname,middle_name,nick_name,image,dob,status,location,program,cameras,users } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataImg = this.img_cdn+image
        this.checkImg = image
        this.oldimage = image
        this.ImgName = image
        this.dataProgram = program
        this.dataFirstName = fname
        this.dataMiddleName = middle_name
        this.dataLastName = lname
        this.dataNick = nick_name
        this.dataCamera = cameras
        this.getLocation(location.id,'edit')
        var getcamusers = [];
        var getcamusersids = [];
        for (let j = 0; j< users.length; j++) {

          getcamusersids.push(users[j].id)
          var getfullname = users[j].fname+' '+users[j].lname+' - '+users[j].email
          users[j].name = getfullname;
          getcamusers.push(users[j])
        }
        this.CamUser=getcamusersids
        this.dataCamUser = getcamusers
        this.dataLocation = location.id
        this.dataBirthday = dob
        this.dataStatus = status

        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      if(this.lng=="dogs"){
      this.dataLastName='pet'
      }
      return !this.errors.any() && this.dataProgram !='' && this.dataFirstName && this.dataLastName && this.dataLocation
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    getLocation(location,msg){
        this.$apollo
          .mutate({
           mutation: GET_CAMERA_BY_LOCATION,
           variables: {
           location_id:location
          }
        })
        .then(response => {
          if (response){
          this.cameras=response.data.location_cameras
          if(msg=='new'){
          this.dataCamera=[]
          }
          }
        }) .catch(error => {
          console.log(error)
      });
       this.$apollo
          .mutate({
           mutation: GET_PROGRAM_BY_LOCATION,
           variables: {
           location_id:location
          }
        })
        .then(response => {
          if (response){
          this.programs=response.data.location_programs
          if(msg=='new'){
          this.dataProgram=[]
          }
          }
        }) .catch(error => {
          console.log(error)
      });
    },
    StatusSuccess() {
      this.$emit('getdata',true)
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Added Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail() {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
   UploadFail(status) {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: status,
        color: 'danger',
        position: 'top-right'
      })
    },
     UpdateSuccess() {
      this.$emit('getdata',true)
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Update Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    UpdateFail() {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Failed to Update!',
        color: 'danger',
        position: 'top-right'
      })
      },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataFirstName = ''
      this.dataMiddleName = ''
      this.dataLastName = ''
      this.dataCategory = null
      this.dataOrder_status = 'pending'
      this.dataPrice = 0
      this.dataImg = null
      this.ImgName = null
      this.oldimage = ''
      this.dataNick = ''
      this.dataProgram = []
      this.dataCamera = []
      this.dataCamUser = []
      this.dataLocation = ''
      this.dataBirthday = ''
      this.dataSibling = ''
      this.dataStatus = false
      this.checkImg=''
      this.cameras=[],
      this.programs=[]
      },
    submitData () {
      this.$validator.validateAll().then(result => {
        var getcamuserids = [];
          for (let j = 0; j< this.dataCamUser.length; j++) {
          var getid = this.dataCamUser[j].id
          getcamuserids.push(getid)
        }
        this.dataCamUser=getcamuserids
         var getcamerasids = [];
          for (let j = 0; j< this.dataCamera.length; j++) {
          var getcameraid = this.dataCamera[j].id
          getcamerasids.push(getcameraid)
        }
        this.dataCamera=getcamerasids
        if (result) {
        if (this.dataId !== null && this.dataId >= 0) {
        var a=this.dataCamUser.sort(function(a, b){return a - b});
        var b=this.CamUser.sort(function(a, b){return a - b});
        function arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;

        for (var i = 0; i < a.length; ++i) {
           if (a[i] !== b[i]) return false;
        }
         return true;
}
          if(this.dataBirthday){
         this.dataBirthday=moment(this.dataBirthday).format("YYYY-MM-DD")
      }
          this.$apollo
          .mutate({
           mutation: UPDATE_STUDENT,
          variables: {
          id:this.dataId,
          fname:this.dataFirstName,
          middle_name:this.dataMiddleName,
          lname: this.dataLastName,
          nick_name: this.dataNick,
          dob:this.dataBirthday,
          image:this.ImgName,
          status: this.dataStatus,
          location_id: this.dataLocation,
          program_id: this.dataProgram.id,
          cameras: this.dataCamera,
          users: this.dataCamUser,
          }
        })
        .then(response => {
          if (response){
          if(!arraysEqual(a, b)){
           this.$apollo
          .mutate({
           mutation: UPDATE_USER_TO_SIBLING,
           variables: {
           student_id: this.data.id,
           users: this.dataCamUser,
          }
        })
        }
            this.UpdateSuccess()
            this.UpadateuserActivity()
          }
        }) .catch(error => {
          console.log(error)

      });

} else {
      if(this.dataBirthday){
         this.dataBirthday=moment(this.dataBirthday).format("YYYY-MM-DD")
      }
          this.$apollo
          .mutate({
           mutation: CREATE_STUDENT,
           variables: {
          fname:this.dataFirstName,
          middle_name:this.dataMiddleName,
          lname: this.dataLastName,
          nick_name: this.dataNick,
          dob:this.dataBirthday,
          image:this.ImgName,
          status: this.dataStatus,
          location_id: this.dataLocation,
          program_id: this.dataProgram.id,
          cameras: this.dataCamera,
          users: this.dataCamUser,
          }
        })
        .then(response => {
          if (response){
            this.StatusSuccess()
            this.userActivity(response.data.createStudent.id)
          }

        }) .catch(error => {
           this.StatusFail()
          console.log(error)
      });
            // delete obj.id
            // obj.popularity = 0
            // this.$store.dispatch('dataList/addStudent', obj).catch(err => { console.error(err) })
          }
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    userActivity ($id) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: $id,
            object_type:"App\\Models\\Student",
            activity:"added"
          }
        })
    },
    UpadateuserActivity () {

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ACTIVITY,
          variables: {
            object_id: this.dataId,
            object_type:"App\\Models\\Student",
            activity:"updated"
          }
        })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        this.checkImg="somthing"
        const reader = new FileReader()
        reader.onload = e => {
        this.dataImg = e.target.result
        this.openLoadingInDiv();
          this.$apollo
          .mutate({
           mutation: UPLOAD_IMAGE,
           variables: {
           image:this.dataImg,
           oldimage:this.oldimage,
          }
        })
        .then(response => {
          if (response){
            this.oldimage=''
            if(response.data.uploadImage.status=="SUCCESS"){
            this.ImgName = response.data.uploadImage.image_name
            // this.dataImg = this.img_cdn+response.data.uploadImage.image_name
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            }
            else{
            this.ImgName = response.data.uploadImage.image_name
            this.UploadFail(response.data.uploadImage.error)
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')

            }

          }
        }) .catch(error => {
          console.log(error)
        });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
   created () {
      this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
      this.lng=process.env.VUE_APP_I18N_LOCALE
      this.$apollo
      .mutate({
        mutation: ME_DATA,
      })
      .then(response => {
        this.meID=response.data.me.id
        this.meRole=response.data.me.roles[0].name
       if(response.data.me.roles[0].name=="manager"){
       this.$apollo
      .mutate({
        mutation: STUDENTS_BY_MANAGER_LOCATION,
        variables: {
        id: response.data.me.id,
     },
      })
        .then(response => {
          this.locations=[]
          for (let i = 0; i < response.data.user.managerlocations.length; i++) {
                  this.locations.push(response.data.user.managerlocations[i])
            }
      })
      }
      })
      if(this.meRole!="manager"){
      this.$apollo
      .mutate({
        mutation: ALL_MANGER_LOCATIONS,
      })
      .then(response => {
        this.locations=response.data.allManagerLocations
      })
      }
       this.$apollo
      .mutate({
        mutation: ALL_USERS,
      })
      .then(response => {
        response.data.role.users.length
         var camusers = [];
       for (let i = 0; i<response.data.role.users.length; i++) {
          var fullname = response.data.role.users[i].fname+' '+response.data.role.users[i].lname+' - '+response.data.role.users[i].email
          response.data.role.users[i].name = fullname;
          camusers.push(response.data.role.users[i])
        }
         this.camusers=camusers
      })
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
